class APIClient {
  static _shared = null;

  baseUrl = process.env.NODE_ENV === 'production' ? 'https://web.panelsapp.com/api' : 'http://panels.localdev/api';
  token = null;

  /** @return APIClient */
  static get shared() {
    if (APIClient._shared === null) {
      APIClient._shared = new APIClient();
    }

    return APIClient._shared;
  }

  constructor() {
    const json = localStorage.getItem('APIClient.token');
    if (json) {
      this.token = JSON.parse(json);
    }
  }

  setToken(token) {
    this.token = token;
    localStorage.setItem('APIClient.token', JSON.stringify(token));
  }

  hasToken() {
    return this.token !== null;
  }

  getComics() {
    return this.get('/comics');
  }

  register(email, password, passwordConfirm) {
    return this.post('/account/register', { email, password, passwordConfirm });
  }

  confirm(id, token) {
    return this.post('/account/confirm', { id, token });
  }

  login(email, password) {
    return this.post('/account/login', { email, password });
  }

  postForgotten(email) {
    return this.post('/account/forgotten', { email });
  }

  postReset(userId, token, password, passwordConfirm) {
    return this.post('/account/reset', { userId, token, password, passwordConfirm });
  }

  getProfile() {
    return this.get('/account/profile');
  }

  /**
   * This should use HTTP PATCH, but the API is crap and doesn't support it.
   */
  postProfile(key, value) {
    const data = {};
    data[key] = value;
    return this.post('/account/profile', data);
  }

  get(path) {
    const options = {
      headers: this.getDefaultHeaders(),
    };

    return fetch(this.baseUrl + path, options)
      .then(this.checkResponse);
  }

  post(path, data) {
    const headers = this.getDefaultHeaders(true);

    const options = {
      method: 'POST',
      headers,
      body: JSON.stringify(data),
    };

    return fetch(this.baseUrl + path, options)
      .then(this.checkResponse);
  }

  getDefaultHeaders(includeContentType) {
    const headers = {
      'Accept': 'application/json',
    };

    if (includeContentType) {
      headers['Content-Type'] = 'application/json';
    }

    if (this.token !== null) {
      headers['Authorization'] = `Bearer ${this.token.token}`;
    }

    return headers;
  }

  checkResponse(res) {
    if (res.status === 204) {
      return Promise.resolve(null);
    } else if (res.status === 403) {
      this.token = null;
    }

    return res.json()
      .then(json => {
        if (!res.ok) {
          throw new Error(json.messages.join('\n'));
        }

        return json;
      });
  }
}

export default APIClient;



// WEBPACK FOOTER //
// ./src/APIClient.js